import createDataCenter from './actions/createDataCenter';
import dataCentersList from './actions/dataCentersList';
import getDataCenter from './actions/getDataCenter';
import updateDataCenter from './actions/updateDataCenter';
import getDataCenters from './getters/getDataCenters';
import uploadDataCenters from './mutations/uploadDataCenters';

const actions = {
    dataCentersList,
    updateDataCenter,
    createDataCenter,
    getDataCenter
};

const mutations = {
    uploadDataCenters
};

const getters = {
    getDataCenters
};

export default { actions, mutations, getters };
